export default function(
  state = {
    popup: false
  },
  action
) {
  switch (action.type) {
    case 'TOGGLEJIOPRIMEPOPUP': {
      return { ...state, popup: !state.popup };
    }
    case 'GET_JIO_PRIME_POINTS': {
      return { ...state, balance: action.balance };
    }
    case 'UPDATE_JIO_PRIME_RECORDS': {
      let newState = { ...state };
      let {
        recordType: type = 'pending',
        recordObj = {},
        pageSize = 10,
        currentPage = 0,
        retainExistingRecord = false
      } = action;

      newState[type] = newState[type] ? { ...newState[type] } : {};
      let {
        totalNoOfRecords = -1,
        userPendingPointDetails = [],
        activePointTransactions = [],
        redeemableTxnDetails = []
      } = recordObj;

      if (totalNoOfRecords > -1) {
        newState[type].totalNoOfRecords = totalNoOfRecords;
      }
      if (userPendingPointDetails.length) {
        newState[type].records =
          newState[type].records && retainExistingRecord ? newState[type].records : [];
        newState[type].records = newState[type].records.concat(userPendingPointDetails);
      }
      if (activePointTransactions.length) {
        newState[type].records =
          newState[type].records && retainExistingRecord ? newState[type].records : [];
        newState[type].records = newState[type].records.concat(activePointTransactions);
      }
      if (redeemableTxnDetails.length) {
        newState[type].records =
          newState[type].records && retainExistingRecord ? newState[type].records : [];
        newState[type].records = newState[type].records.concat(redeemableTxnDetails);
      }
      newState[type].pageSize = pageSize;
      newState[type].currentPage = currentPage;
      return newState;
    }

    case 'RESET_JIO_PRIME_RECORDS': {
      let newState = { ...state };
      let { recordType: type = 'pending' } = action;
      if (newState[type]) {
        newState[type] = { ...state[type], records: [] };
        newState[type].pageSize = 10;
        newState[type].currentPage = 0;
      }
      return newState;
    }
    default:
      return state;
  }
}
